<template>
  <div class="topic" v-bind:class="{hover: isHover}" @mouseover="mouseOver" @mouseout="mouseOver">
    <div><img :src="isHover ? item.img2 : item.img"/></div>
    <div style="padding-top: 24px; padding-left: 8px; padding-right: 8px;">
        <span class="title">{{item.name}}</span>
        <br>
        <span class="description">{{item.description}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Topic',
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      isHover: false
    }
  },
  methods: {
    mouseOver () {
      this.isHover = !this.isHover
    }
  }
}
</script>
<style>
.centro-de-ayuda .topic {
  background: #FFFFFF;
  border: 1.67837px solid #F2F2F2;
  box-shadow: 0px 3.05063px 6px rgba(159, 159, 159, 0.16);
  border-radius: 16px;
  margin-bottom: 16px;
  padding-bottom: 21px;
  cursor: pointer;
  display: flex;
}
.centro-de-ayuda .topic.hover {
  background: #0855C4;
}
.centro-de-ayuda .topic img {
  padding-top: 16px;
  padding-left: 8px;
}
.centro-de-ayuda .topic .title {
  font-family: 'Omnes Regular'!important;
  font-style: normal!important;
  font-weight: 700!important;
  font-size: 16px!important;
  line-height: 15px!important;
  vertical-align: calc(100% - 10px)!important;
}
.centro-de-ayuda .topic.hover .title {
  color: white!important;
}
.centro-de-ayuda .topic .description {
  font-family: 'Omnes Regular'!important;
  font-style: normal!important;
  font-weight: 400!important;
  font-size: 16px!important;
  line-height: 15px!important;
}
.centro-de-ayuda .topic.hover .description {
  color: white!important;
}
</style>



// WEBPACK FOOTER //
// src/components/help-center/Topic.vue